import styled from "styled-components";

export const BodyLogin = styled.div`
  background-color: #f3f3f3;
  width: 100%;
  height: 100vh;
  display: flex;
`;

export const Img = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #184bb4;
`;

export const MyLogin = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FormLogin = styled.form`
  width: 370px;
  display: flex;
  flex-direction: column;
`;

export const ContentTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 38px;
`;

export const TitleLogin = styled.h1`
  color: #000;
  font-size: 32px;
`;
